import Tobii from "@midzer/tobii";

require("./header.js");
require("./scrolled.js");

require("./rsce_faq.js");
require("./rsce_news_slider.js");
require("./rsce_testimonials.js");

const tobii = new Tobii()

const AOS = require("aos");

AOS.init({
    duration: 600,
    easing: 'ease-out-sine',
    startEvent: 'load'
});

document.querySelectorAll("img").forEach(img => {
    img.addEventListener("load", () => {
        AOS.refresh();
    })
})

document.body.classList.add("loaded");